<app-dtc-table-search
  (searchTriggered)="onSearchTriggered($event)"
  [downloadDisabled]="true"
  [restoreDisabled]="true"
  [recyclingModeEnabled]="false"
  [helpPopoverEnabled]="false"
  [displaySwPartNumberSelection]="false"
  [languageSelection]="false"
></app-dtc-table-search>
<div
  #scrollContainer
  class="relative overflow-x-auto shadow-md sm:rounded-lg min-h-[calc(100vh-224px)] max-h-[calc(100vh-224px)] overflow-y-auto mt-2"
>
  <table class="w-full text-sm text-left rtl:text-right text-gray-500">
    <thead class="text-xs uppercase bg-amazone-orange text-gray-100 sticky top-0">
      <tr>
        <th scope="col" class="px-6 py-3">
          <div class="flex items-center">
            <input
              [disabled]="isReadOnly"
              (change)="toggleAllSelection()"
              [ngModel]="isAllSelected()"
              id="select-all-dtc"
              type="checkbox"
              value=""
              class="w-4 h-4 text-amazone-orange bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 focus:ring-2 disabled:bg-gray-200 disabled:cursor-not-allowed"
            />
            <label for="select-all-dtc" class="ms-2 text-xs">Auswählen</label>
          </div>
        </th>
        <th scope="col" class="px-6 py-3">
          <app-header-sorter
            [headerTitle]="'Dtc'"
            [field]="getPropertyName('number')"
            [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('number'))"
            (clicked)="sortBy($event)"
          ></app-header-sorter>
        </th>
        <th scope="col" class="px-6 py-3">
          <app-header-sorter
            [headerTitle]="'Implementation Hint'"
            [field]="getPropertyName('implementationHint')"
            [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('implementationHint'))"
            (clicked)="sortBy($event)"
          ></app-header-sorter>
        </th>
        <th scope="col" class="px-2 py-3">
          <app-header-sorter
            [headerTitle]="'Assigned to other EM'"
            [field]="getPropertyName('errorMessageId')"
            [arrow]="sortingConfiguration.getArrowDirection(getPropertyName('errorMessageId'))"
            (clicked)="sortBy($event)"
          ></app-header-sorter>
        </th>
      </tr>
    </thead>
    <tbody>
      @if (dtcs?.length === 0) {
        <tr>
          <td class="px-6 py-4 text-center font-medium text-amazone-orange whitespace-nowrap" colspan="7">
            No dtcs found
          </td>
        </tr>
      }
      @for (dtc of dtcs; let i = $index; track $index) {
        <tr class="odd:bg-white even:bg-gray-50 border-b border-gray-200 hover:bg-gray-100 hover:text-amazone-orange">
          <td class="px-6 py-4">
            <input
              [disabled]="isReadOnly"
              (ngModelChange)="toggleSelection(dtc.id!)"
              [ngModel]="selectedDtcs.get(dtc.id!)"
              type="checkbox"
              value=""
              class="w-4 h-4 text-amazone-orange bg-gray-100 border-gray-300 rounded-sm focus:ring-blue-500 focus:ring-2 disabled:bg-gray-200 disabled:cursor-not-allowed"
            />
          </td>
          <td class="px-6 py-4 font-semibold whitespace-nowrap">
            {{ dtc?.displayId ?? 'N/A' }}
          </td>
          <td class="px-6 py-4">
            {{ dtc?.implementationHint ?? 'N/A' }}
          </td>
          <td class="px-6 py-4">
            @if (dtc?.errorMessageId && dtc?.errorMessageId !== errorMessageId) {
              <div class="relative @5xl:hidden block">
                <app-exclamation-triangle-icon
                  (mouseenter)="showErrorMessage(dtc.errorMessageId, i)"
                  (mouseleave)="hideErrorMessage()"
                ></app-exclamation-triangle-icon>
                <div
                  role="tooltip"
                  class="absolute z-10 right-10 inline-block w-64 text-sm text-gray-500 transition-opacity duration-300 bg-white border border-gray-300 rounded-lg shadow-md"
                  [class.invisible]="hoveredErrorMessageId !== dtc.errorMessageId || hoveredIndex !== i"
                  [class.opacity-0]="hoveredErrorMessageId !== dtc.errorMessageId || hoveredIndex !== i"
                  [class.visible]="hoveredErrorMessageId === dtc.errorMessageId && hoveredIndex === i"
                  [class.opacity-100]="hoveredErrorMessageId === dtc.errorMessageId && hoveredIndex === i"
                >
                  <div class="px-3 py-2 bg-gray-50 border-b border-gray-200 rounded-t-lg">
                    <h3 class="font-semibold text-amazone-orange">EM-Code: {{ dtc.errorMessage?.code }}</h3>
                  </div>
                  <div class="px-3 py-2">
                    <p>{{ dtc.errorMessage?.detailsOnTerminal }}</p>
                  </div>
                </div>
              </div>
              <div class="@5xl:block hidden">
                {{ dtc?.errorMessage?.code }} - {{ dtc?.errorMessage?.headerOnTerminal }}
              </div>
            } @else {
              <span class="ms-1.5">-</span>
            }
          </td>
        </tr>
      }
    </tbody>
  </table>
</div>
